import { WalletTransactionPage } from '../../components/WalletTransactionPage';

export default function WithdrawPage() {
  return <WalletTransactionPage mode="withdraw" />;
}
